import { Translate, useTranslate } from '~/i18n';
import styles from './styles.module.css';
import groupBy from 'lodash/groupBy';
import { DetailsCollapsableSection } from '../collapsable-section';

type ItineraryProps = {
   itinerary: string | ParsedItineraryItem[];
};

type ParsedItineraryItem = {
   day: string;
   description: { [key: string]: string };
   time: string;
};

const Itinerary = ({ itinerary }: ItineraryProps) => {
   const parsed: ParsedItineraryItem[] =
      typeof itinerary === 'object' ? itinerary : JSON.parse(itinerary);
   const groups: { [key: string]: ParsedItineraryItem[] } = groupBy(parsed, item => item.day);
   const lang = useTranslate().lang?.split('-')[1] as 'ar' | 'en';

   return (
      <DetailsCollapsableSection title={<Translate id="common:itinerary" />}>
         <ul className="mt-6">
            {Object.entries(groups).map(([day, items], index) => (
               <li key={index} className={styles.item}>
                  <div className="mb-2 text-lg font-bold">
                     <Translate id="booking:day" /> {day}
                  </div>
                  <div>
                     {items.map(({ description, time }, itemIndex) => (
                        <div key={itemIndex} className="mb-2">
                           <span className="font-bold">- {time}:</span> {description[lang]}
                        </div>
                     ))}
                  </div>
               </li>
            ))}
         </ul>
      </DetailsCollapsableSection>
   );
};

export default Itinerary;
